<div class="follow-beatmaker-block">
  <p class="follow-beatmaker-block__name">
    Follow <span class="follow-beatmaker-block__name--bold">{{ producer?.beatmakerName }}</span>
  </p>

  <div class="follow-beatmaker-block__contacts">
    <bmcore-social-icons [socialContacts]="producer?.contacts"></bmcore-social-icons>
  </div>
</div>
